<template>
	<div>
		<modalconfirm ref="modalconfirmAddOpname" @action="proccessOpname"/>
		<div class="text-h5">Approval Stok Opname</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pb-5">
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form ref="formOpname">
					<v-row class="pb-5">
            <v-col cols="12" sm="4" md="4">
							<v-autocomplete :items="opnameforApprove" v-model="product_stock_opname_code" item-value="product_stock_opname_code" @change="getDetail(product_stock_opname_code)" label="Stok Opname" no-data-text="Tidak ada data yang sesuai" outlined dense @focus="responseError.product_stock_opname_id = ''" :error-messages="responseError.product_stock_opname_id" hide-details="auto" class="width-0">
								<template v-slot:item = {item}>
									{{ item.product_stock_opname_code }} - {{ item.warehouse_name }}
								</template>
								<template v-slot:selection = {item}>
									{{ item.product_stock_opname_code }}
								</template>
							</v-autocomplete>
						</v-col>
          </v-row>
          <v-row class="pb-5">
						<v-col cols="12" md="4">
							<v-text-field outlined dense readonly v-model="detailOpname.product_stock_opname_pic_name" label="Penanggung Jawab"></v-text-field>
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field outlined dense readonly v-model="detailOpname.product_stock_opname_datetime" label="Tanggal Opname"></v-text-field>
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field outlined dense readonly v-model="detailOpname.warehouse_name" label="Warehouse"></v-text-field>
						</v-col>
						<v-col cols="12" sm="4" md="4">
							<v-textarea v-model="detailOpname.product_stock_opname_note" label="Catatan" rows="3" height="100" @focus="() => responseError.note=''" :error-messages="responseError.note" hide-details="auto" outlined dense readonly no-resize></v-textarea>
						</v-col>
						<v-col cols="12" class="pb-5">
							<v-simple-table>
								<template v-slot:default>
									<thead class="v-data-table-header">
										<tr>
											<th width="5%" class="text-left">No.</th>
											<th width="40%" class="text-left">Nama Produk</th>
											<th width="10%" class="text-left">Kode Produk</th>
											<th width="10%" class="text-left">Jumlah</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(product, index) in detailOpname.product_stock_opname_detail" :key="index">
											<td>
												<div class="pt-2">{{ index + 1}}</div>
											</td>
											<td>
												<div class="pt-2">{{ product.product_stock_opname_detail_product_name }}</div>
											</td>
											<td>
												<div class="pt-2">{{ product.product_code }}</div>
											</td>
											<td>
												<div class="pt-2">{{ product.product_stock_opname_detail_quantity }}</div>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4" v-if="detailOpname && detailOpname.opname_status == 'created'">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" outlined depressed class="text-capitalize" @click="rejectOpname">Tolak</v-btn>
				<v-btn color="primary darken-1" depressed class="text-capitalize" @click="approveOpname">Proses</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
  data() {
		return {
      status: '',
      product_stock_opname_code : '',
    }
  },
	computed: {
		...mapState('stockOpname', ['response', 'responseError', 'alertMultiple', 'detailOpname', 'opnameforApprove']),
	},
	methods: {
		...mapActions('stockOpname', ['approvalOpname', 'getDetailOpname', 'getOptionOpnameforApprove']),
		...mapMutations('stockOpname', ['saveResponse', 'clearDataOpname']),
		...mapMutations(['setOverlay']),

    getDetail(code) {
      // code = 'OPN22061013533410'
			this.getDetailOpname(code)
		},
		rejectOpname() {
      this.status = 'rejected'
      this.$refs.modalconfirmAddOpname.setMessage('Apakah Anda yakin akan menolak transaksi ini?')
      this.$refs.modalconfirmAddOpname.showConfirm()
		},
		approveOpname() {
      this.status = 'approved'
      this.$refs.modalconfirmAddOpname.setMessage('Apakah Anda yakin akan memproses transaksi ini?')
      this.$refs.modalconfirmAddOpname.showConfirm()
		},
		async proccessOpname() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmAddOpname.hideConfirm()
			let params = await {
				opname_id: this.detailOpname.product_stock_opname_id,
				status: this.status,
			}
			await this.approvalOpname(params).then(() => {
				if (this.response.code == 200.) {
					this.resetForm()
				}
			})
			await this.setOverlay(false)
		},
		resetForm(){
			this.saveResponse({
				code: '',
				message: '',
			})
      this.clearDataOpname()
      this.getOptionOpnameforApprove()
		}
	},
	created() {
    this.getOptionOpnameforApprove()
		this.$store.dispatch('setPageTitle', `Approval Stok Opname`)
    if (this.$route.params.code) {
			this.product_stock_opname_code = this.$route.params.code
			this.getDetail(this.$route.params.code)
		}
	},
	beforeDestroy() {
		this.clearDataOpname()
	},
}
</script>
